<div class="position-fixed top-0 end-0 p-3" style="z-index: 5">
    <div class="toast align-items-center text-white {{valid}} border-0" id="toast-ok">
        <div class="d-flex">
            <div class="toast-body">
                {{body}}
            </div>
        </div>
    </div>
</div>